import { createTheme, Grid, MuiThemeProvider } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import React from "react";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import getDefaultGridOptions, {
    defaultHeaderOptions
} from "../../utils/componentUtils";
import utilsDate from "../../utils/Date";
import { useStyles } from "../../utils/DefaultStyles";

type props = {
    control: any;
    name: string;
};

const LogList: React.FC<props> = ({ control, name }) => {
    const classes = useStyles();
    const { t: tGeneral } = useTranslation("General");

    const { fields } = useFieldArray({
        control,
        name: name,
    });

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: "",
                },
            },
        },
    });

    const columns = [
        {
            name: "createdAt",
            label: tGeneral("dateTime"),
            options: {
                ...defaultHeaderOptions,
                customBodyRender: (
                    value: any,
                    tableMeta: any,
                    updateValue: any
                ) => {
                    return utilsDate.DateTimeShort(value);
                },
            },
        },
        {
            name: "logTypeDescription",
            label: tGeneral("action"),
            options: defaultHeaderOptions,
        },
        {
            name: "createdBy",
            label: tGeneral("user"),
            options: defaultHeaderOptions,
        },
    ];

    return (
        <Grid
            style={{
                marginTop: 20,
                width: "98%",
                marginLeft: 10,
                marginBottom: 10,
            }}
        >
            <div className={classes.rootContent}>
                <MuiThemeProvider theme={myTheme}>
                    <MUIDataTable
                        title=""
                        data={fields}
                        columns={columns}
                        options={{
                            ...getDefaultGridOptions(tGeneral),
                            serverSide: false,
                            pagination: false,
                            sortOrder: {
                                name: 'createdAt',
                                direction: 'desc'
                            },
                            selectToolbarPlacement: "none",
                            filter: false,
                            search: false,
                            download: false,
                            print: false,
                            viewColumns: false,
                            selectableRows: "none",
                        }}
                    />
                </MuiThemeProvider>
            </div>
        </Grid>
    );
};
export default LogList;
